import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_144: DocMigration = {
  maxSchemaVersion: "0.0.144",
  description: "Cleanup unused param config fields",
  apply(json: any) {
    const { params } = json;

    for (const paramId in params) {
      const param = params[paramId];
      if (param.config) {
        delete param.config.affectsGrossOutputs;
        delete param.config.unitType;
        delete param.config.preferredPresentationMode;
        delete param.config.disabledPresentationModes;
      }
    }

    return json;
  },
};

export default migration_0_0_144;
